import { logger } from "logging";
import { toLowerCase } from "./toLowerCase";

/**
 * @description
 * checks if user is on chrome browser
 * @returns boolean whether chrome browser or not
 */
export const checkIsChromeBrowser = () => {
  try {
    let ua = toLowerCase(navigator.userAgent);
    if (ua.indexOf("chrome") > -1) {
      return true; // Chrome browser
    }
  } catch (error) {
    logger.error(error, "Error in checkIsChromeBrowser");
  }
  return false; // Any other browser
};
